import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMediaServersSummaryVm } from '../media-servers-summary-vm.model';
import { IMediaServerVm } from '../media-server-vm.model';
import { IMediaServerUm } from '../media-server-um.model';

@Injectable({ providedIn: 'root' })
export class MediaServersService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MediaServers`;
  }

  get(): Observable<IMediaServersSummaryVm> {
    const headers = this.createHeaders();
    return this.http.get<IMediaServersSummaryVm>(this.baseUrl, { headers });
  }

  put(mediaServerUm: IMediaServerUm): Observable<IMediaServerVm> {
    const headers = this.createHeaders();
    return this.http.put<IMediaServerVm>(this.baseUrl, mediaServerUm, { headers });
  }

  delete(mediaServerGuid: string): Observable<void> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    params = params.set('mediaServerGuid', mediaServerGuid);
    return this.http.delete<void>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
